/**
 * Shared school-selection normalization (trim, non-empty, dedupe)—aligned with CPS
 * `executeJobSchoolPublish` / publish payload rules. Used by staff “Publish and update” for both
 * immediate (`PUT …/publish` + `update-pos-student-plans`) and scheduled (`update-pos-student-plans`
 * with `deferredSchoolPublish` only).
 */

export const EMPTY_SCHOOL_SELECTION_PUBLISH_AND_UPDATE_MESSAGE =
  'Select at least one school with a valid school id before publishing.';

/**
 * Trims each id, drops blank entries, dedupes while preserving first-seen order.
 */
export function normalizeCheckedSchoolNidsForPublishAndUpdate(
  checkedSchoolNids: readonly string[]
): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of checkedSchoolNids) {
    const nid = String(raw).trim();
    if (!nid || seen.has(nid)) {
      continue;
    }
    seen.add(nid);
    out.push(nid);
  }
  return out;
}

/**
 * Requires at least one school NID (throws with {@link EMPTY_SCHOOL_SELECTION_PUBLISH_AND_UPDATE_MESSAGE}).
 * Used by publish-and-update drawer and `usePublishAndUpdatePlanOfStudy` before data-ingest enqueue.
 */
export function requireNonEmptySchoolNidsForPublishAndUpdate(
  checkedSchoolNids: readonly string[] | undefined
): string[] {
  const nids = normalizeCheckedSchoolNidsForPublishAndUpdate(checkedSchoolNids ?? []);
  if (nids.length === 0) {
    throw new Error(EMPTY_SCHOOL_SELECTION_PUBLISH_AND_UPDATE_MESSAGE);
  }
  return nids;
}
